export default "__VITE_ASSET__tBWt9zjH__"